/* =========================================================================
   Foxhills Guided Add-to-Bag (AbbottLyon-style, multi-step)
   On standard product pages this REPLACES the inline add-to-cart flow:
   - hides the inline size selector + HulkApps gift-bag option
   - relabels the button to "Complete the Look & Add to Bag"
   - intercepts the add and runs a guided slide-in: size -> engrave -> gift wrap
   - does its own /cart/add.js (gift wrap as a linked separate line via
     _giftwrap_key, exactly like AbbottLyon) then opens the cart drawer.
   Config injected by snippets/fox-guided-atb.liquid as window.FoxATB.
   ========================================================================= */
(function () {
  'use strict';

  var CFG = window.FoxATB;
  if (!CFG || !CFG.enabled || !CFG.product) return;

  var P = CFG.product;
  var PANEL_ID = 'FoxATBPanel';
  var GBHANDLE = CFG.giftBagHandle;
  var state, giftBag = null, steps = [], stepIdx = 0;

  function money(c) { try { return theme.Currency.formatMoney(c, theme.settings.moneyFormat); } catch (e) { return '£' + (c / 100).toFixed(2); } }
  function q(s, r) { return (r || document).querySelector(s); }
  function avail() { return P.variants.filter(function (v) { return v.available; }); }
  function defVar() { var a = avail(); return (a[0] || P.variants[0] || {}).id; }
  function needSize() { return !P.hasOnlyDefaultVariant && P.variants.length > 1; }
  function firstAvail(p) { if (!p || !p.variants) return null; return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0] || null; }

  /* ---------- steps ---------- */

  // Only the size choice belongs in the guided panel. Engraving is handled by the
  // product's own HulkApps options (the rich laser flow); gift wrap lives in the cart.
  function buildSteps() {
    var s = [];
    if (needSize()) s.push({ key: 'size', title: 'Choose ' + (CFG.optionName || 'size') });
    return s;
  }

  function needsPanel() { return needSize(); }

  function stepContent(step) {
    if (step.key === 'size') {
      // Show a thumbnail per choice when the variants have their own images
      // (chain types etc). Ring sizes and the like have no per-variant image,
      // so those stay as text-only cards.
      var haveImgs = P.variants.some(function (v) { return v.featured_image && v.featured_image.src; });
      return '<div class="fox-atb__opts' + (haveImgs ? ' fox-atb__opts--imgs' : '') + '">' + P.variants.map(function (v) {
        var img = '';
        if (haveImgs) {
          var src = (v.featured_image && v.featured_image.src) || CFG.productImage || '';
          if (src) img = '<img class="fox-atb__opt-img" src="' +
            src.replace(/(\.[^.?\/]*)(\?|$)/, '_360x$1$2') + '" alt="" loading="lazy">';
        }
        return '<button type="button" class="fox-atb__opt' + (v.available ? '' : ' is-disabled') +
          (state.variantId === v.id ? ' is-selected' : '') + '" data-variant="' + v.id + '"' +
          (v.available ? '' : ' disabled') + '>' + img +
          '<span class="fox-atb__opt-title">' + v.title + '</span>' +
          '<span class="fox-atb__opt-price">' + (v.available ? money(v.price) : 'Sold out') + '</span></button>';
      }).join('') + '</div>';
    }
    if (step.key === 'engrave') {
      return '<input type="text" class="fox-atb__engrave" maxlength="20" value="' + (state.engraving || '') +
        '" placeholder="Up to 20 characters"><p class="fox-atb__hint">Leave blank to skip.</p>';
    }
    if (step.key === 'giftwrap') {
      var gv = giftBag ? firstAvail(giftBag) : null;
      var gbPrice = gv ? money(gv.price) : '';
      var img = giftBag && giftBag.featured_image ? giftBag.featured_image.replace(/(\.[^.?]*)(\?|$)/, '_200x$1$2') : '';
      return '<div class="fox-atb__gw-card">' +
        (img ? '<img class="fox-atb__gw-img" src="' + img + '" alt="">' : '') +
        '<label class="fox-atb__gw-row"><input type="checkbox" class="fox-atb__gw-check"' + (state.giftWrap ? ' checked' : '') + '>' +
        '<span class="fox-atb__gw-text">Add a gift bag</span><em class="fox-atb__gw-price">' + gbPrice + '</em></label>' +
        '<p class="fox-atb__gw-sub">The finishing touch, beautifully gift-wrapped.</p></div>';
    }
    return '';
  }

  function render() {
    var el = document.getElementById(PANEL_ID);
    if (!el) return;
    var step = steps[stepIdx], isLast = stepIdx === steps.length - 1;
    var dots = steps.map(function (s, i) { return '<span class="fox-atb__dot' + (i === stepIdx ? ' is-on' : '') + '"></span>'; }).join('');
    q('.fox-atb__steps', el).innerHTML =
      '<div class="fox-atb__progress">' + dots + '</div>' +
      '<div class="fox-atb__step-h">' + step.title + '</div>' +
      '<div class="fox-atb__step-body">' + stepContent(step) + '</div>';
    q('.fox-atb__back', el).style.visibility = stepIdx === 0 ? 'hidden' : 'visible';
    q('.fox-atb__next', el).textContent = isLast ? 'Add to bag' : 'Continue';
    var eng = q('.fox-atb__engrave', el); if (eng) eng.addEventListener('input', function () { state.engraving = eng.value.trim(); });
    var gw = q('.fox-atb__gw-check', el); if (gw) gw.addEventListener('change', function () { state.giftWrap = gw.checked; });
  }

  /* ---------- open / close ---------- */

  function open() {
    close(true);
    state = { variantId: needSize() ? null : defVar(), engraving: '', giftWrap: false };
    steps = buildSteps();
    stepIdx = 0;
    var el = document.createElement('div');
    el.id = PANEL_ID;
    el.className = 'fox-atb';
    el.innerHTML =
      '<div class="fox-atb__overlay" data-close></div>' +
      '<aside class="fox-atb__panel" role="dialog" aria-label="Add to bag">' +
        '<div class="fox-atb__head"><span class="fox-atb__title">Complete the look</span>' +
          '<button type="button" class="fox-atb__close" data-close aria-label="Close">&times;</button></div>' +
        '<div class="fox-atb__product">' + P.title + '</div>' +
        '<div class="fox-atb__steps"></div>' +
        '<div class="fox-atb__footer">' +
          '<button type="button" class="fox-atb__back">Back</button>' +
          '<button type="button" class="fox-atb__next">Continue</button>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(el);
    document.documentElement.classList.add('fox-atb-open');
    fetch('/products/' + GBHANDLE + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (gb) { giftBag = gb; if (steps[stepIdx] && steps[stepIdx].key === 'giftwrap') render(); })
      .catch(function () {});
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    render();
    el.addEventListener('click', onClick);
    document.addEventListener('keydown', onKey);
  }

  function close(immediate) {
    var el = document.getElementById(PANEL_ID);
    document.documentElement.classList.remove('fox-atb-open');
    document.removeEventListener('keydown', onKey);
    if (!el) return;
    if (immediate) { el.remove(); return; }
    el.classList.remove('is-open');
    setTimeout(function () { if (el.parentNode) el.remove(); }, 260);
  }

  function onKey(e) { if (e.key === 'Escape') close(); }

  function onClick(ev) {
    var el = document.getElementById(PANEL_ID);
    if (!el) return;
    if (ev.target.closest('[data-close]')) { close(); return; }
    var opt = ev.target.closest('.fox-atb__opt');
    if (opt && !opt.disabled) {
      state.variantId = parseInt(opt.getAttribute('data-variant'), 10);
      Array.prototype.forEach.call(el.querySelectorAll('.fox-atb__opt'), function (o) { o.classList.toggle('is-selected', o === opt); });
      var box = el.querySelector('.fox-atb__opts'); if (box) box.classList.remove('fox-atb__opts--error');
      return;
    }
    if (ev.target.closest('.fox-atb__back')) { if (stepIdx > 0) { stepIdx--; render(); } return; }
    if (ev.target.closest('.fox-atb__next')) { next(el); return; }
  }

  function next(el) {
    var step = steps[stepIdx];
    if (step.key === 'size' && !state.variantId) {
      var box = el.querySelector('.fox-atb__opts'); if (box) box.classList.add('fox-atb__opts--error');
      return;
    }
    if (stepIdx < steps.length - 1) { stepIdx++; render(); return; }
    confirmAdd(el);
  }

  function confirmAdd(el) {
    var items = [{ id: state.variantId || defVar(), quantity: 1, properties: {} }];
    if (state.engraving) items[0].properties['Engraving'] = state.engraving;
    if (state.giftWrap && giftBag) {
      var gv = firstAvail(giftBag);
      if (gv) {
        var key = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
        items[0].properties['_giftwrap_key'] = key;
        items.push({ id: gv.id, quantity: 1, properties: { _giftwrap_key: key, _giftwrap_parent_title: P.title } });
      }
    }
    if (!Object.keys(items[0].properties).length) delete items[0].properties;
    var btn = q('.fox-atb__next', el);
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { close(); if (window.jQuery) window.jQuery('body').trigger('added.ajaxProduct'); })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Add to bag'; } });
  }

  /* ---------- intercept the add-to-cart (ALWAYS handle here) ---------- */

  function isAdd(t) { return t && t.closest && t.closest('.product-single__form button[name="add"], button.add-to-cart, .add-to-cart'); }
  document.addEventListener('click', function (ev) {
    var btn = isAdd(ev.target);
    if (!btn) return;
    if (btn.closest('.shopify-payment-button')) return;
    if (btn.closest('#FoxAddonRail')) return;
    // No real choice to make? Let it add normally and open the cart drawer.
    if (!needsPanel()) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    open();
  }, true);

  /* ---------- PDP: relabel button + hide the inline options we now own ---------- */

  function applyPdp() {
    // Keep the button label as "Add to cart". Only hide the HulkApps options when
    // the stepper actually takes over the add (multi-variant size products), so
    // engraving + other HulkApps options stay visible/working on single-variant items.
    document.documentElement.classList.add('fox-atb-pdp');
    if (needSize()) document.documentElement.classList.add('fox-atb-hidehulk');
  }
  if (document.readyState !== 'loading') applyPdp();
  else document.addEventListener('DOMContentLoaded', applyPdp);
})();
